/**
 * Provides method for trapping focus in a specified container.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
const trapFocus = ( e: KeyboardEvent, firstTabStop: HTMLElement, lastTabStop: HTMLElement, closeMenu: Function ) => {
  if ( e.key === 'Tab' ) {
    if ( e.shiftKey ) {
      if ( document.activeElement === firstTabStop ) {
        e.preventDefault()
        lastTabStop.focus()
      }
    } else if ( document.activeElement === lastTabStop ) {
      e.preventDefault()
      firstTabStop.focus()
    }
  }
  if ( e.key === 'Escape' ) closeMenu()
}

export default trapFocus
